function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.0469 5.76562H3.10742L6.82812 2.57227C7.12109 2.30859 7.15039 1.86914 6.91602 1.57617C6.65234 1.2832 6.21289 1.25391 5.91992 1.48828L0.763672 5.91211C0.617188 6.08789 0.5 6.26367 0.5 6.46875C0.5 6.67383 0.617188 6.87891 0.763672 7.02539L5.91992 11.4492C6.03711 11.5664 6.21289 11.625 6.35938 11.625C6.56445 11.625 6.76953 11.5371 6.91602 11.3613C7.15039 11.0684 7.12109 10.6289 6.82812 10.3652L3.10742 7.17188H11.0469C12.7461 7.17188 14.0938 8.51953 14.0938 10.1895V13.6758C14.0938 14.1445 14.416 14.4375 14.7969 14.4375C15.207 14.4375 15.5 14.1445 15.5 13.7344V10.248C15.5 7.78711 13.5078 5.76562 11.0469 5.76562Z",
  fill: "#767B87"
});

const SvgWithdrawSubmission = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgWithdrawSubmission, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/withdraw_submission.5d28301a.svg";
export { ForwardRef as ReactComponent };